module.exports = __webpack_public_path__ + "img/forgot-password-light.fbdea8e6.svg";